// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"08c89f67","840":"6bb8a1a2","988":"de20b162"}[chunkId] + ".chunk.js";
};